/* eslint-disable complexity */
import { BookWidgetDateField } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

const parseDateParts = (parts: number[]): Date | null => {
  if (parts.length !== 3) return null;
  const [first, second, third] = parts;

  // Detect format: if first part > 31, it's a year (YYYY-MM-DD or YYYY/MM/DD)
  // Otherwise it's month/day first (MM-DD-YYYY or MM/DD/YYYY)
  const isYearFirst = first > 31;
  const year = isYearFirst ? first : third;
  const month = isYearFirst ? second : first;
  const day = isYearFirst ? third : second;

  return new Date(year, month - 1, day);
};

const parseLocalDate = (dateString: string): Date | null => {
  if (!dateString) return null;
  const separator = dateString.includes('-')
    ? '-'
    : dateString.includes('/')
    ? '/'
    : null;
  if (!separator) return null;
  return parseDateParts(dateString.split(separator).map(Number));
};

export const prepareDatesField = (
  queryParams: QueryParams | null,
  retrieveSearchData: RetrieveSearchData | null,
  hasDeepLinkingParams: boolean
): BookWidgetDateField => {
  let dates: SelectedRange[] = [{ start: null, end: null, total: 0 }];

  if (queryParams?.departureDate) {
    dates = [
      {
        start: queryParams.departureDate
          ? parseLocalDate(queryParams.departureDate)
          : null,
        end: queryParams.returnDate
          ? parseLocalDate(queryParams.returnDate)
          : null,
        total: 0
      }
    ];
  } else if (!hasDeepLinkingParams && retrieveSearchData?.dates?.length) {
    dates = retrieveSearchData.dates.map((dateObject) => {
      return {
        total: 0,
        start: dateObject.departureDate
          ? parseLocalDate(dateObject.departureDate)
          : null,
        end: dateObject.returnDate
          ? parseLocalDate(dateObject.returnDate)
          : null
      };
    });
  }

  return { dates };
};
